/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { Menu, Button } from 'antd';
import { Link, useLocation } from 'react-router-dom';

import arrowLeft from 'assets/svg/arrow-to-left.svg';
import arrowRight from 'assets/svg/arrow-to-right.svg';
import { ReactComponent as Chat } from 'assets/svg/chat.svg';
import { ReactComponent as Customer } from 'assets/svg/customer.svg';
import { ReactComponent as Dashboard } from 'assets/svg/dashboard.svg';
import { ReactComponent as Expense } from 'assets/svg/expense.svg';
import { ReactComponent as Product } from 'assets/svg/product-menu.svg';
import { ReactComponent as Report } from 'assets/svg/report.svg';
import { ReactComponent as Seller } from 'assets/svg/seller.svg';
import { ReactComponent as Settings } from 'assets/svg/settings.svg';
import { ReactComponent as Shop } from 'assets/svg/shop.svg';
import { ReactComponent as Warehouse } from 'assets/svg/warehouse.svg';
import { SidebarCollapse } from 'store/actions/ConfigAction';
import { ConfigContext } from 'store/context';
import Auxiliary from 'util/Auxiliary';
import { isChatEnabled } from 'util/chatAvailability';

import SidebarLogo from './SidebarLogo';
import UserProfile from './UserProfile';
import { usePermissions } from '../../hooks/usePermissions';

function resolveSelectedKey(pathname, drawer, openDrawer) {
  if (drawer && openDrawer) return drawer;

  return pathname.split('/')[1];
}

function SidebarContent({ toogleSubmenu, drawer, openDrawer }) {
  const { pathname } = useLocation();

  const { can } = usePermissions();
  const {
    ConfigState: { statusCollapse: status },
    ConfigDispatch,
  } = useContext(ConfigContext);

  const selectedKeys = resolveSelectedKey(pathname, drawer, openDrawer);

  return (
    <Auxiliary>
      <Button
        type="primary"
        onClick={() => ConfigDispatch(SidebarCollapse())}
        className="omi-arrow-menu"
        shape="circle"
      >
        <img src={status ? arrowRight : arrowLeft} alt="arrow-left" />
      </Button>
      <SidebarLogo />
      <div className="omi-sidebar-content">
        <Menu selectedKeys={[selectedKeys]} mode="inline">
          <Menu.Item key="dashboard">
            <Link to="/dashboard" onClick={() => toogleSubmenu('')}>
              <div className="omi-menu-icon inline-block">
                <Dashboard />
              </div>
              <p>Bảng điều khiển</p>
            </Link>
          </Menu.Item>

          {(can('viewPOSRegister') || can('viewPOS') || can('viewPOSOrderList') || can('viewPOSSettingList')) && (
            <Menu.Item key="pos">
              <a href="#" onClick={() => toogleSubmenu('pos')}>
                <div className="omi-menu-icon inline-block">
                  <Seller />
                </div>
                <p>Điểm bán</p>
              </a>
            </Menu.Item>
          )}

          {(can('viewProductList') || can('viewCategoryList') || can('viewUOMList') || can('viewTagList')) && (
            <Menu.Item key="product">
              <a href="#" onClick={() => toogleSubmenu('product')}>
                <div className="omi-menu-icon inline-block">
                  <Product />
                </div>
                <p>Sản phẩm</p>
              </a>
            </Menu.Item>
          )}

          {(can('viewCustomerList') || can('viewCustomerGroupList')) && (
            <Menu.Item key="customers">
              <a href="#" onClick={() => toogleSubmenu('customer')}>
                <div className="omi-menu-icon inline-block">
                  <Customer />
                </div>
                <p>Khách hàng</p>
              </a>
            </Menu.Item>
          )}

          {isChatEnabled && (
            <Menu.Item key="chat">
              <Link to="/chat" onClick={() => toogleSubmenu('')}>
                <div className="omi-menu-icon inline-block">
                  <Chat />
                </div>
                <p>Hội thoại</p>
              </Link>
            </Menu.Item>
          )}

          {(can('viewPurchaseOrderList') || can('viewSupplierReturnList') || can('viewVendorList')) && (
            <Menu.Item key="purchase">
              <a href="#" onClick={() => toogleSubmenu('purchase')}>
                <div className="omi-menu-icon inline-block">
                  <Shop />
                </div>
                <p>Nhập hàng</p>
              </a>
            </Menu.Item>
          )}
          {(can('viewInventoryList') || can('viewScrapList') || can('viewPurchaseOrderList')) && (
            <Menu.Item key="stock">
              <a href="#" onClick={() => toogleSubmenu('stock')}>
                <div className="omi-menu-icon inline-block">
                  <Warehouse />
                </div>
                <p>Kho hàng</p>
              </a>
            </Menu.Item>
          )}
          {can('viewExpenseList') && (
            <Menu.Item key="expense">
              <a href="#" onClick={() => toogleSubmenu('expense')}>
                <div className="omi-menu-icon inline-block">
                  <Expense />
                </div>
                <p>Sổ quỹ</p>
              </a>
            </Menu.Item>
          )}
          {can('viewReportInventoryValuation') && (
            <Menu.Item key="report">
              <a href="#" onClick={() => toogleSubmenu('report')}>
                <div className="omi-menu-icon inline-block">
                  <Report />
                </div>
                <p>Báo cáo</p>
              </a>
            </Menu.Item>
          )}

          {can('viewSetting') ? (
            <Menu.Item key="setting">
              <Link to="/settings" onClick={() => toogleSubmenu('')}>
                <div className="omi-menu-icon inline-block">
                  <Settings />
                </div>
                <p>Cấu hình</p>
              </Link>
            </Menu.Item>
          ) : null}
        </Menu>
      </div>
      <div className="omi-sidebar-footer">
        <UserProfile />
      </div>
    </Auxiliary>
  );
}

export default SidebarContent;
